import { PRODUCT_TOUR_PAGE } from '@/constants/routes';
import Link from 'next/link';
import { FC } from 'react';
import { ButtonElement } from '../Button';
import { Text } from '../Text';
import { TextCombination } from '../TextCombination';

type ManagedTrialConfirmationProps = {
  onDemoClick: () => void;
}

export const ManagedTrialConfirmation: FC<ManagedTrialConfirmationProps> = ({ onDemoClick }) => {
  return (
    <>
      <TextCombination
        type="h3p2"
        align="left"
        title="We offer a customized trial experience for teams of your size."
        description="A Front specialist will be in touch shortly to help you get started. In the meantime, take Front for a spin with an interactive product tour."
      />
      <Text type="p2" className="text-secondary"></Text>
      <Link href={PRODUCT_TOUR_PAGE} target='_blank'>
        <ButtonElement
          variant="primary"
          buttonType="filled"
          text="Take a tour"
          onClick={onDemoClick}
        />
      </Link>
    </>
  );
};
